export default __webpack_public_path__ + "static/media/lighthouseVaLogo.164b2c30.png";